<ag-grid-angular
  class="ag-theme-balham"
  [rowData]="rowData"
  [columnDefs]="columnDefs"
  [defaultColDef]="defaultColDef"
  [overlayNoRowsTemplate]="overlayNoRowsTemplate"
  [components]="components"
  [animateRows]="hasRowAnimation"
  [multiSortKey]="multiSortKey"
  [pagination]="pagination"
  [paginationPageSize]="paginationPageSize"
  [rowSelection]="hasMultipleRows"
  [suppressRowClickSelection]="true"
  (selectionChanged)="onSelectionChanged()"
  (rowDataUpdated)="onRowDataUpdated()"
  (rowClicked)="onRowClicked($event)"
  (sortChanged)="onSortChanged($event)"
  (columnResized)="onColumnResized()"
  (gridReady)="onGridReady($event)"
  (paginationChanged)="onPaginationChanged($event)"
>
</ag-grid-angular>
